// Central map of route path -> browser tab title. Keeps per-page <title>
// consistent without editing every page component. Used by Layout.

const SUFFIX = 'Avenues Portal';

// Exact pathname matches.
const EXACT = {
  '/': 'Sign In',
  '/forgot-password': 'Forgot Password',
  '/reset-password': 'Reset Password',

  '/therapist/dashboard': 'Dashboard',
  '/therapist/daily-log-multi': 'Log Sessions',
  '/therapist/messages': 'Messages',
  '/therapist/pay-history': 'Pay History',
  '/therapist/debt': 'Debt Sessions',
  '/therapist/billing-history': 'Billing History',
  '/therapist/tools': 'Tools',
  '/therapist/resources': 'Resources',
  '/therapist/notes': 'Session Notes',
  '/therapist/team': 'Team',
  '/therapist/client-profile': 'Client Profiles',

  '/admin/dashboard': 'Admin Dashboard',
  '/admin/daily-report': 'Daily Report',
  '/admin/debt-records': 'Debt Records',
  '/admin/messages': 'Messages',
  '/admin/payroll': 'Payroll',
  '/admin/submission-log': 'Submission Log',
  '/admin/qb-export': 'QuickBooks Export',
  '/admin/invoice': 'Invoice',
  '/admin/new-user': 'New User',
  '/admin/users': 'Manage Users',
  '/admin/tools': 'Admin Tools',
  '/admin/server': 'Server & Portal Info',
  '/admin/payment': 'Payment',
  '/admin/payment-links': 'Payment Links',
  '/therapist/sent-links': 'Sent Links',
  '/admin/bonuses': 'Bonuses',
  '/admin/clients': 'Clients',
  '/admin/assign-form': 'Assign Form',
  '/admin/intake-link': 'New Client Intake',
  '/admin/new-client-requests': 'New Client Requests',
  '/admin/resources': 'Resources',
  '/admin/canvas': 'Canvas',
  '/admin/retirement': 'Retirement',

  '/intake': 'Client Intake',
  '/update-card': 'Update Card',
  '/roi': 'Release of Information',
  '/school-consent': 'School Services Consent',
};

// Prefix matches for dynamic routes (e.g. /forms/fill/:formId).
const PREFIX = [
  ['/forms/fill/', 'Fill Out Form'],
];

export function titleForPath(pathname) {
  let page = EXACT[pathname];
  if (!page) {
    const hit = PREFIX.find(([p]) => pathname.startsWith(p));
    if (hit) page = hit[1];
  }
  return page ? `${page} · ${SUFFIX}` : SUFFIX;
}
